import styles from './style.m.less';

interface SettingsRowProps {
    label: React.ReactNode;
    children: React.ReactNode;
}

const SettingsRow = ({ label, children }: SettingsRowProps) => (
    <div className={styles.item}>
        <label className={styles.leftSide}>{label}</label>
        <div className={styles.rightSide}>{children}</div>
    </div>
);

export default SettingsRow;
